import * as React from "react";

import { Box, Step, StepConnector, StepLabel, StepLabelProps, Stepper, styled, useMediaQuery } from "@mui/material";

import { stepConnectorClasses } from "@mui/material/StepConnector";

interface IAddAddressStepperProps {
  steps: string[];
  activeStep: number;
  onNodeClick?: (data: number) => void;
  hideLabel?: boolean;
}

interface StyledStepLabelProps extends StepLabelProps {
  index: number;
  activeStep: number;
}

const StyledStepLabel = styled(({ index, activeStep, ...otherProps }: StyledStepLabelProps) => (
  <StepLabel {...otherProps} />
))(({ theme, index, activeStep }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return {
    "& .MuiStepIcon-root": {
      fill: index === activeStep ? theme.palette.primary.main : index < activeStep ? "#F7DC8D" : "#E8DFD7",
      height: isMobile ? "20px" : "24px",
      width: isMobile ? "20px" : "24px",
      background: "radial-gradient(#000000 30%, transparent 50%)",
      borderRadius: "50%",
    },
    "& .MuiStepIcon-text": {
      fill: index === activeStep ? theme.palette.warning.main : theme.palette.gray.dark,
      fontSize: isMobile ? "8px" : "14px",
      fontWeight: 600,
    },
  };
});

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: "FEC20B",
  },
}));

const CustomStepper: React.FC<IAddAddressStepperProps> = ({ steps, activeStep, onNodeClick, hideLabel=false }) => {
  return (
    <Box sx={{ display: "flex", width: "100%", justifyContent: "center" }}>
      <Stepper
        sx={{
          width: "95%",
          color: (theme) => theme.palette.warning.main,
          fontFamily: "Test Geograph",
        }}
        alternativeLabel
        activeStep={activeStep}
        connector={<CustomConnector />}
      >
        {steps.map((label, index) => (
          <Step
            key={label}
            className={`${onNodeClick ? "cursor-pointer" : ""}`}
            onClick={() => onNodeClick && onNodeClick(index)}
          >
            <StyledStepLabel index={index} activeStep={activeStep}>
              {!hideLabel && <span className={`${index === activeStep ? "text-light-black" : "text-gray-1"}
              text-sm mt-0 font-semibold cursor-default`}>
                {label}
              </span>}
            </StyledStepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default CustomStepper;
